export const MAX_NUMBER_OF_COMPONENTS = 100;
